import { Application } from '@hotwired/stimulus'

import ChargeablePaymentTermController from './chargeable_payment_term_controller'
import ClickToCopyController from './click_to_copy_controller'
import CreditCardFormController from './credit_card_form_controller'
import ExperienceSelectorController from './experience_selector_controller'
import PackageSelectController from './package_select_controller'
import PaymentTermSelectorController from './payment_term_selector_controller'
import PaymentTermsController from './payment_terms_controller'
import PayNowFormController from './pay_now_form_controller'
import QuantityController from './quantity_controller'
import RoomingListsController from './rooming_lists_controller'
import RoomListController from './room_list_controller'
import ToggleContentController from './toggle_content_controller'

const application = Application.start()

application.register('chargeable-payment-term', ChargeablePaymentTermController)
application.register('click-to-copy', ClickToCopyController)
application.register('credit-card-form', CreditCardFormController)
application.register('experience-selector', ExperienceSelectorController)
application.register('package-select', PackageSelectController)
application.register('payment-term-selector', PaymentTermSelectorController)
application.register('payment-terms', PaymentTermsController)
application.register('pay-now-form', PayNowFormController)
application.register('quantity', QuantityController)
application.register('rooming-lists', RoomingListsController)
application.register('room-list', RoomListController)
application.register('toggle-content', ToggleContentController)
